import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from '../utility';

const apiBase = 'fuelContract';
const plural = 'fuelContracts';
const word = 'fuel contract';

export const search = (p = {}) => {
	const { callback = _.noop, afterDate } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: { afterDate },
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate: 'fuelContractIds',
			params,
			dispatch,
			successMessage: `The ${word} was created successfully. 
				Click continue to return to the ${word} page.`,
			onSuccessRedirectTo: `/inventoryManagement/${plural}`,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage: `The ${word} updated successfully. 
				Click continue to return to the ${word} page.)`,
			onSuccessRedirectTo: `/inventoryManagement/${plural}`,
			callback,
		});
	};
};

export const remove = ({ fuelContractId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			id: fuelContractId,
			dispatch,
			callback,
		});
	};
};
